import {
  NumberType,
  PhoneType,
} from "@redotech/redo-model/support/phone/phone-types";
import * as z from "zod/v4";
import { object, string } from "zod/v4";
export const setupPhoneNumber = {
  name: "setupPhoneNumber" as const,
  input: object({
    phoneNumber: string(),
    phoneType: z.enum(PhoneType),
    numberType: z.enum(NumberType),
    termsOfUseUrl: string().optional(),
    privacyPolicyUrl: string().optional(),
  }),
  output: object({}),
};

export type SetupPhoneNumberInput = z.infer<typeof setupPhoneNumber.input>;
export type SetupPhoneNumberOutput = z.infer<typeof setupPhoneNumber.output>;
